/** Codes CPV principaux (divisions et groupes courants) */
export const CPV_CODES = [
  // Agriculture, sylviculture, pêche
  { code: '03000000', label: 'Produits agricoles, de l\'élevage, de la pêche, de la sylviculture' },
  // Produits miniers, pétrole
  { code: '09000000', label: 'Produits pétroliers, combustibles, électricité et autres sources d\'énergie' },
  // Produits alimentaires
  { code: '15000000', label: 'Denrées alimentaires, boissons, tabac' },
  // Textile
  { code: '18000000', label: 'Vêtements, chaussures, articles de bagagerie' },
  // Cuir
  { code: '19000000', label: 'Cuir et textiles, matériaux en plastique et en caoutchouc' },
  // Pétrochimie
  { code: '24000000', label: 'Produits chimiques' },
  // Machines industrielles
  { code: '30000000', label: 'Machines de bureau et matériel informatique' },
  { code: '31000000', label: 'Machines, appareils, équipements et consommables électriques' },
  { code: '32000000', label: 'Équipements de radio, de télévision, de communication et de télécommunication' },
  { code: '33000000', label: 'Matériels médical, pharmaceutique et produits de soins personnels' },
  { code: '34000000', label: 'Équipements de transport et produits auxiliaires' },
  { code: '35000000', label: 'Équipements de sécurité et de défense' },
  // Instruments
  { code: '38000000', label: 'Équipements de laboratoire, d\'optique et de précision' },
  { code: '39000000', label: 'Mobilier, aménagement, appareils électroménagers' },
  // Construction
  { code: '44000000', label: 'Matériaux de construction et articles connexes' },
  { code: '45000000', label: 'Travaux de construction' },
  { code: '45100000', label: 'Travaux de préparation de chantier' },
  { code: '45200000', label: 'Travaux de construction de bâtiments ou de génie civil' },
  { code: '45300000', label: 'Travaux d\'installation dans les bâtiments' },
  { code: '45400000', label: 'Travaux de parachèvement de bâtiments' },
  // Logiciels & IT
  { code: '48000000', label: 'Logiciels et systèmes d\'information' },
  { code: '48100000', label: 'Logiciels pour l\'industrie' },
  { code: '48200000', label: 'Logiciels de réseau, Internet et Intranet' },
  { code: '48300000', label: 'Logiciels de gestion de documents' },
  { code: '48400000', label: 'Logiciels de gestion de transactions commerciales' },
  { code: '48500000', label: 'Logiciels de communication et multimédia' },
  { code: '48600000', label: 'Logiciels de bases de données et d\'exploitation' },
  { code: '48700000', label: 'Utilitaires logiciels' },
  { code: '48800000', label: 'Systèmes d\'information et serveurs' },
  { code: '48900000', label: 'Logiciels et systèmes divers' },
  // Réparation & Entretien
  { code: '50000000', label: 'Services de réparation et d\'entretien' },
  { code: '50300000', label: 'Services de réparation et d\'entretien de machines' },
  // Services d\'installation
  { code: '51000000', label: 'Services d\'installation' },
  // Services de réparation hôtellerie
  { code: '55000000', label: 'Services d\'hôtellerie, de restauration et de commerce' },
  // Transport
  { code: '60000000', label: 'Services de transport (sauf transports de déchets)' },
  // Poste & Télécommunications
  { code: '64000000', label: 'Services des postes et télécommunications' },
  // Services financiers
  { code: '66000000', label: 'Services financiers et d\'assurance' },
  // Immobilier
  { code: '70000000', label: 'Services immobiliers' },
  // Architecture & Ingénierie
  { code: '71000000', label: 'Services d\'architecture, de construction, d\'ingénierie et d\'inspection' },
  { code: '71200000', label: 'Services d\'architecture' },
  { code: '71300000', label: 'Services d\'ingénierie' },
  { code: '71500000', label: 'Services liés à la construction' },
  // Services IT
  { code: '72000000', label: 'Services de technologies de l\'information' },
  { code: '72100000', label: 'Services de conseil en matériel informatique' },
  { code: '72200000', label: 'Services de programmation et de conseil en logiciels' },
  { code: '72300000', label: 'Services de traitement de données' },
  { code: '72400000', label: 'Services Internet' },
  { code: '72500000', label: 'Services informatiques' },
  { code: '72600000', label: 'Services d\'assistance et de conseil informatiques' },
  { code: '72700000', label: 'Services de réseau informatique' },
  { code: '72800000', label: 'Services d\'audit informatique et d\'essais informatiques' },
  { code: '72900000', label: 'Services de sauvegarde et de conversion de données' },
  // Recherche
  { code: '73000000', label: 'Services de recherche et développement' },
  // Services comptables
  { code: '74000000', label: 'Services de conseils scientifiques et techniques' },
  // Services aux entreprises
  { code: '75000000', label: 'Services d\'administration publique, de défense et de sécurité sociale' },
  { code: '76000000', label: 'Services liés à l\'industrie du pétrole et du gaz' },
  // Environnement
  { code: '77000000', label: 'Services agricoles, forestiers, horticoles, d\'aquaculture et d\'apiculture' },
  // Formation
  { code: '79000000', label: 'Services aux entreprises : droit, marketing, conseil, recrutement, impression' },
  { code: '79100000', label: 'Services juridiques' },
  { code: '79200000', label: 'Services de comptabilité, d\'audit et services fiscaux' },
  { code: '79300000', label: 'Études de marché et recherche économique' },
  { code: '79400000', label: 'Services de conseil en gestion' },
  { code: '79500000', label: 'Services d\'appui bureautique' },
  { code: '79600000', label: 'Services de recrutement' },
  { code: '79700000', label: 'Services d\'enquête et de sécurité' },
  { code: '79800000', label: 'Services d\'impression et services connexes' },
  { code: '79900000', label: 'Services divers aux entreprises' },
  // Éducation
  { code: '80000000', label: 'Services d\'enseignement et de formation' },
  // Santé
  { code: '85000000', label: 'Services de santé et services sociaux' },
  // Loisirs & Culture
  { code: '92000000', label: 'Services récréatifs, culturels et sportifs' },
  // Assainissement & Déchets
  { code: '90000000', label: 'Services d\'évacuation des eaux usées et d\'élimination des déchets' },
  { code: '90500000', label: 'Services liés aux déchets et ordures' },
  { code: '90600000', label: 'Services de nettoyage et d\'hygiène' },
  { code: '90700000', label: 'Services relatifs à l\'environnement' },
  // Eau & Énergie
  { code: '65000000', label: 'Services publics' },
];
